/**
 * actionsheet 组件
 * author     zijianyang
 * date       2018/12/5
 *
 * 使用示例：
 * import actionSheet from "common/actionSheet.js";
 * actionSheet.show({
 *     noFilterXSS  : false, // 默认为false，可不配置
 *     actionList : [
 *         "示例菜单1", // 支持富文本，但需将 noFilterXSS 置为 true
 *         "示例菜单2",
 *         "示例菜单3",
 *         "示例菜单4"
 *     ],
 *     actionCfgList:[{
 *          isTitle:true,
 *
 *      },{
 *          isDanger:true
 *      }],
 *     clickCbk : function (index) { // 用户选中了第几个选项，index从0开始
 *         xxxxx
 *     },
 *     cancelCbk : function () {     // 用户点击取消或阴影区域，actionsheet隐藏
 *         xxxx
 *     }
 * })
 */
import Env from 'common/env.js';
import Event from '../base/event.js';
import * as Str from '../base/string.js';
var Format = Str.format;
import './actionSheet.less';

let exportData;
if(!Env.isCSR) {
    (function(win, doc) {
        var tpl = `
            <div class="weui-mask js_action_sheet_cancel" style="opacity: 1;"></div>
            <div class="weui-actionsheet wg-actionsheet__border-radius">
                <div class="weui-actionsheet__menu">
                    {list_html}
                </div>
                <div class="weui-actionsheet__action js_action_sheet_cancel" id="weui-actionsheet__action_btn">
                    <div class="weui-actionsheet__cell">取消</div>
                </div>
            </div>
        `;
        var itemTpl = `<div class="weui-actionsheet__cell js_action_sheet_item {classStyle}" data-index="{index}">{actionText}</div>`

        function insertHtml(html) {
            var id  = "as_" + parseInt(Math.random() * 1000000);
            var dom = document.createElement('div');
    
            dom.id = id;
            dom.innerHTML = html;
    
            // 阻止body的滚动
            dom.addEventListener('touchmove', (e) => {
                e.stopPropagation();
                e.preventDefault();
            })
    
            doc.body.appendChild(dom);
    
            setTimeout(function(){
                var weuiactionsheet = document.getElementsByClassName('weui-actionsheet');
                if( weuiactionsheet.length > 0){
                    weuiactionsheet     = weuiactionsheet[weuiactionsheet.length -1];
                    weuiactionsheet.classList.add('weui-actionsheet_toggle');
                }
    
                var isLiuhai = Env.isIosLiuhai;
                if( isLiuhai ){
                    var btnDiv = document.getElementById('weui-actionsheet__action_btn');
                    if( btnDiv ){
                        btnDiv.classList.add('iosx');
                    }
                }
            },50);
            return dom;
        }

        var ActionSheet = {
            show: function (params) {
    
                if( !params || !params.actionList ) {   throw "params.actionList is empty"; return;    }
                const noFilterXSS = !params.noFilterXSS; // 传true变false format不xss转义 不传或传false 变true format默认true
    
                params.actionCfgList = params.actionCfgList || [];
                var listHmtl = "",
                    html     = "",
                    domCnt;
    
                for( var i = 0, len = params.actionList.length; i < len; i++ ) {
                    var cfg = params.actionCfgList[i] || {};

                    var classStyle = {};
                    if( cfg.isTitle ){
                        classStyle['weui-actionsheet__title'] = true;
                    }
                    if( cfg.isDanger ){
                        classStyle['weui-actionsheet__danger'] = true;
                    }
                    listHmtl += Format(itemTpl, {
                        classStyle   : Object.keys(classStyle).join(' '),
                        index      : i,
                        actionText : params.actionList[i]
                    }, noFilterXSS)
                }
                html = Format(tpl, { list_html : listHmtl }, false);
    
                domCnt = insertHtml(html);
                
                this.bindEvent( domCnt, params.clickCbk, params.cancelCbk, params.autoSetGameTab );
                
                params.autoSetGameTab !== false && WXGAME && WXGAME.WxBridge.invoke("setGameTab", {isShowTab: 0})
            },
            bindEvent : function (dom, clickCbk, cancelCbk, autoSetGameTab = true) {
                if( !dom ) return;
    
                if(clickCbk){
                    var list = dom.getElementsByClassName('js_action_sheet_item');
                    for(var i = 0, len = list.length; i < len; i++){
                        if (list[i].classList.contains('weui-actionsheet__title')) { // 标题不需要事件
                            continue;
                        }
                        Event.click( list[i], function(evt, tar) {
                            // 如果传入的是一个html 那么这里的target就会是传入的html里面渲染出来的元素 会不存在data-index导致getAttrbute拿不到对应的index 手动做个冒泡先拿到预期中的dom元素
                            // js_action_sheet_item必定会存在于其中一级 因为前面统一加入
                            let i = 0;
                            while (tar && tar.className.indexOf('js_action_sheet_item') === -1 && i < 5) {
                                tar = tar.parentNode;
                                i++;
                            }
                            var index = parseInt( tar.getAttribute("data-index") );
                            dom.parentNode.removeChild(dom);
                            clickCbk(index);

                            autoSetGameTab && WXGAME && WXGAME.WxBridge.invoke("setGameTab", {isShowTab: 1})
                        });
                    }
                }
    
                var list = dom.getElementsByClassName('js_action_sheet_cancel');
                for(var i = 0, len = list.length; i < len; i++){
                    Event.click( list[i], function(evt, tar) {
                        cancelCbk();
                        dom.parentNode.removeChild(dom);

                        autoSetGameTab && WXGAME && WXGAME.WxBridge.invoke("setGameTab", {isShowTab: 1})
                    });
                }
    
            },
        }

        exportData = ActionSheet;
    })(window, document);
}else{
    exportData = {show: function() {}, bindEvent: function() {}};
}

export default exportData;